import React, { useState, useEffect } from 'react';
import './PricingCardIslam.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import SubscriptionModal from './SubscriptionModal';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Footer from './Footer2';

const PricingCard = () => {
  const navigate = useNavigate();

  const [lessons, setLessons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deviceFingerprint, setDeviceFingerprint] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [errorMessages, setErrorMessages] = useState({});
  const [filter, setFilter] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // ============================
  // FETCH LESSONS
  // ============================
  const fetchLessons = async () => {
    setLoading(true);
    try {
      const educationalLevelId = localStorage.getItem("educationalLevelId");
      const authToken = localStorage.getItem("authToken");
      const Teacher_id = localStorage.getItem("teacher_id");

      if (!authToken || !educationalLevelId) {
        navigate("/CardIslam");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/getPackages/3/${educationalLevelId}`,
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      setLessons(response.data.packages || []);

      if (!response.data.packages.length) {
        alert("لا يوجد محاضرات متاحة.");
      }

    } catch (err) {
      setError(err);
      alert("حدث خطأ أثناء تحميل المحاضرات.");
    } finally {
      setLoading(false);
    }
  };

  // ============================
  // FINGERPRINT
  // ============================
  useEffect(() => {
    const fetchFingerprint = async () => {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        setDeviceFingerprint(result.visitorId);
        localStorage.setItem("deviceFingerprint", result.visitorId);
      } catch (err) {
        setErrorMessages(prev => ({ ...prev, global: "تعذر جلب البصمة" }));
        navigate("/LoginIslam");
      }
    };

    fetchLessons();
    fetchFingerprint();
  }, [navigate]);

  // ============================
  // SUBSCRIBE
  // ============================
  const handleSubscribeClick = lesson => {
    localStorage.setItem("package_id", lesson.id);
    setSelectedLesson(lesson);
    setIsModalOpen(true);
  };

  // ============================
  // ENTER LESSON
  // ============================
  const handleEnterClick = async lesson => {
    localStorage.setItem("package_id", lesson.id);

    const id = localStorage.getItem("id");
    const subscriptionCode = localStorage.getItem("subscriptionCode");
    const deviceFingerprint = localStorage.getItem("deviceFingerprint");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/code/check/${id}/${deviceFingerprint}/${lesson.id}?code=${subscriptionCode}`
      );

      if (response.data.message === "User has a valid code.") {
        navigate("/lecIslam");
      } else {
        setErrorMessages(prev => ({
          ...prev,
          [lesson.id]: "الكود غير صالح أو يوجد مشكلة."
        }));
      }

    } catch (error) {
      const msg = error.response?.data?.message;

      let text = "من فضلك ادخل الكود.";
      if (msg === "MAC address mismatch." || msg === "No code found for this user and lesson.") {
        text = "برجاء الدخول من اول جهاز تم الاشتراك عليه";
      }
      setErrorMessages(prev => ({ ...prev, [lesson.id]: text }));
    }
  };

  // ============================
  // BLOCK DEVTOOLS
  // ============================
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "F12" || (e.ctrlKey && (e.key === "u" || (e.shiftKey && e.key === "I")))) {
        e.preventDefault();
      }
    };
    const disableMenu = e => e.preventDefault();

    document.addEventListener("keydown", handleKey);
    document.addEventListener("contextmenu", disableMenu);

    return () => {
      document.removeEventListener("keydown", handleKey);
      document.removeEventListener("contextmenu", disableMenu);
    };
  }, []);

  // ============================
  // MOBILE CHECK
  // ============================
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ============================
  // FILTER
  // ============================
  const filteredLessons = lessons.filter((lesson) => {
    if (!filter) return lessons;
    const t = lesson.title.toLowerCase();

    if (filter === "month") return t.includes("شهر");
    if (filter === "lecture") return t.includes("محاضر");
    if (filter === "offer") return t.includes("عرض");

    return lessons;
  });

  const handleFilterClick = (value) => {
    setFilter(value);
    fetchLessons();
  };

  return (
    <>
      {/* زر المراجعه */}
  
      {/* فلاتر */}
      <div className="filter-container">
        <button className="filterButtonStyle" onClick={() => handleFilterClick("month")}>الشهور</button>
        <button className="filterButtonStyle" onClick={() => handleFilterClick("lecture")}>المحاضرات</button>
        <button className="filterButtonStyle" onClick={() => handleFilterClick("offer")}>العروض</button>
      </div>

      {/* الكروت */}
      <div className="page-container">
        <div className="profile-card">
          <div className="pricing-cards animiL">

            {loading ? (
              <p>Loading...</p>
            ) : filteredLessons.length === 0 ? (
              <p>لا يوجد نتائج</p>
            ) : (
   filteredLessons.map((lesson) => (
  <div key={lesson.id} className="card glassy-card">
    
    <div className="card-header">
      <h2>{lesson.title}</h2>
    </div>

    <div className="card-image">
      <img src={"/images/ES/sas.jpg"} alt={lesson.title} />
    </div>

    <div className="card-body">
      <p className="lesson-description">{lesson.description}</p>
      {errorMessages[lesson.id] && (
        <p className="error">{errorMessages[lesson.id]}</p>
      )}
    </div>

    <div className="card-footer">
      <button className="gradient-btn" onClick={() => handleEnterClick(lesson)}>دخول</button>
      <button className="btn subscribe-btn" onClick={() => handleSubscribeClick(lesson)}>اشتراك</button>
    </div>

    {isModalOpen && selectedLesson?.id === lesson.id && (
      <SubscriptionModal
        lesson={selectedLesson}
        onClose={() => setIsModalOpen(false)}
      />
    )}
  </div>
))

            )}

          </div>
                  <div className="profile-card">
          <div className="pricing-cards animiL">
           
  <div key={1} className="card glassy-card">
    
    <div className="card-header">
      <h2>باقة الترم</h2>
    </div>

    <div className="card-image">
      <img src={"/images/ES/sas.jpg"}  />
    </div>

    <div className="card-body">
      <p className="lesson-description">باقة الترم ...جنيها</p>
     
    </div>

    <div className="card-footer">
      <button className="gradient-btn" onClick={() => handleEnterClick()}>دخول</button>
      <button className="btn subscribe-btn" onClick={() => handleSubscribeClick()}>اشتراك</button>
    </div>

=  </div>

          </div>
        </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PricingCard;
